export const formatDate = (date: Date): string => {
  const renewalMonth = date.toLocaleDateString(undefined, {
    month: 'short',
  });

  return renewalMonth + ' ' + date.getDate() + ', ' + date.getFullYear();
};
